'use client';

import type { EventBusListener } from '@hc-frontend/core-events';
import type { LinkClickEvent } from '@hc-frontend/core-ui';
import { useEventBus } from '@hc-frontend/core-ui';
import { trackUserClick } from '@hc-frontend/third-party-snowplow';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect } from 'react';

import { useSmidContext } from '../../hooks/use-smid-context';
import {
  queryCategory,
  queryClickDataById,
} from './link-events-subscription-lookup';

export function LinkEventsSubscription() {
  const eventBus = useEventBus();
  const pathname = usePathname();
  const smidContext = useSmidContext();

  const handleLinkClick = useCallback<EventBusListener<LinkClickEvent>>(
    (event) => {
      if (event.href.startsWith('tel:')) {
        window.nbpix?.('event', 'call_button');
      }
      const eventData = queryClickDataById(event.id);
      trackUserClick(
        eventData ?? {
          elementId: event.id,
          label: event.label ?? event.source.innerText,
          value: event.source.innerText,
          targetUrl: event.href,
          action: 'click',
          category: event.category ?? queryCategory(pathname),
          placement: event.placement ?? 'content',
        },
        smidContext ? [...(event.contexts ?? []), smidContext] : event.contexts,
      );
    },
    [pathname, smidContext],
  );

  useEffect(() => {
    eventBus.subscribe('core.ui.link.click', handleLinkClick);

    return () => {
      eventBus.unsubscribe('core.ui.link.click', handleLinkClick);
    };
  }, [handleLinkClick, eventBus]);

  return null;
}
